import { getBossConfig, getBossDownConfig, getCheatInfo } from 'yxt-biz-pc/packages/kng-audit-content/service';
import commonUtil from 'yxt-biz-pc/packages/common-util';
import {
  getDefinitionConfig,
  getSkillTagOpenStatus,
  getWatermarkConfig,
  getMultiConfig,
  getFaceConfig,
  getRestTimeOfAI,
  getRewardState,
  getUploadLimit
} from '../service';
import utils from 'packages/common-util/utils';
import { KNG_FILE_TYPE } from '../../select-kng/src/const';
export default {
  provide() {
    return {
      getWaterConfig: () => this.waterConfig,
      getMultiConfig: () => this.multiConfig,
      getFaceConfig: () => this.faceConfig,
      getUploadLimitConfig: () => this.uploadLimitConfig,
      getPermissionConfig: () => this.permissionConfig,
      getEnableUploadZip: () => this.enableUploadZip
    };
  },
  data() {
    const knowledgeConfigKey =
  (window.uploadConfigKeys && window.uploadConfigKeys.KnowledgeConfigKey) || {};
    return {
      waterConfig: {}, // 水印配置（平台）
      multiConfig: {}, // 倍速配置（机构）
      faceConfig: {}, // 人脸配置（机构）
      uploadLimitConfig: {
        [KNG_FILE_TYPE.IMAGE]: knowledgeConfigKey.imageMaxFileSize || 10240,
        [KNG_FILE_TYPE.WORD]: knowledgeConfigKey.docMaxFileSize || 102400,
        [KNG_FILE_TYPE.ZIP]: knowledgeConfigKey.zipMaxFileSize || 1048576,
        [KNG_FILE_TYPE.AUDIO]: knowledgeConfigKey.audioMaxFileSize || 204800,
        [KNG_FILE_TYPE.VIDEO]: knowledgeConfigKey.videoMaxFileSize || 2097152,
        [KNG_FILE_TYPE.EXCEL]: knowledgeConfigKey.docMaxFileSize || 102400,
        [KNG_FILE_TYPE.SCORM]: 307200,
        [KNG_FILE_TYPE.HTML]: 307200,
        [KNG_FILE_TYPE.PPT]: knowledgeConfigKey.docMaxFileSize || 102400,
        [KNG_FILE_TYPE.PDF]: knowledgeConfigKey.docMaxFileSize || 102400
      },
      permissionConfig: {
        editCredits: true, // 编辑学分权限
        editHours: true // 编辑学时权限
      },
      enableUploadZip: true
    };
  },
  created() {
    // 配置查询
    this.setDefinition();
    this.setDownloadState();
    this.setDownloadFileTypes();
    this.setWatermarkConfig();
    this.setMultiConfig();
    this.setCheatInfo();
    this.setFaceConfig();
    this.setAITime();
    this.setRewardState();
    this.setPermissionConfig();
    // this.getZipOrgParams();
  },
  methods: {
    /** 配置类查询 */
    async setRewardState() {
      try {
        const res = await getRewardState();
        this.config.openReward = res === 1;
      } catch (e) {
        console.log(e);
      }
    },
    // 清晰度
    async setDefinition() {
      try {
        const res = await getDefinitionConfig();
        this.config.definitionOpened = res.enabled === '1';
        this.config.sizeLimitOpened = res.extremeEnabled === '1';
      } catch (e) {
        console.log(e);
      }
    },
    // 能力标签
    async setSkillTagStatus() {
      try {
        await getSkillTagOpenStatus();
        this.config.skillTagOpened = true;
        return;
      } catch (e) {
        console.log(e);
      }
      this.config.skillTagOpened = false;
    },
    async setUploadLimitConfig() {
      try {
        const res = await getUploadLimit();
        this.uploadLimitConfig[KNG_FILE_TYPE.IMAGE] = Number(res.imageMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.WORD] = Number(res.docMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.PPT] = Number(res.docMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.PDF] = Number(res.docMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.EXCEL] = Number(res.docMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.ZIP] = Number(res.zipMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.AUDIO] = Number(res.audioMaxFileSize);
        this.uploadLimitConfig[KNG_FILE_TYPE.VIDEO] = Number(res.videoMaxFileSize);
        res.scormMaxFileSize && (this.uploadLimitConfig[KNG_FILE_TYPE.SCORM] = Number(res.scormMaxFileSize));
        res.htmlMaxFileSize && (this.uploadLimitConfig[KNG_FILE_TYPE.HTML] = Number(res.htmlMaxFileSize));
      } catch (e) {
        console.log(e);
      }
    },
    // boss 下载开关状态
    async setDownloadState() {
      try {
        const bodyParams = {
          group: 'DOWNLOAD_GROUP',
          key: 'DOWNLOAD_SWITCH',
          orgId: localStorage.orgId || ''
        };
        const res = await getBossConfig(bodyParams);
        this.config.isBossCanDownload = !(res.config === 'null' || res.config === null || res.config === 'false' || res.config === '0');
      } catch (e) {
        console.log(e);
      }
    },
    // boss 可下载的文档类型
    async setDownloadFileTypes() {
      try {
        const orgId = localStorage.orgId || '';
        const map = {
          1: 'isBossCanDownloadDoc',
          2: 'isBossCanDownloadVideo',
          3: 'isBossCanDownloadAudio'
        };
        const res = await getBossDownConfig(orgId);
        res.forEach(item => {
          this.config[map[item.fileType]] = !!item.openFlag;
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 水印配置
    async setWatermarkConfig() {
      try {
        const res = await getWatermarkConfig();
        let {enabled, type, watermarkContent, otherColor, otherAlpha, otherFontSize} = res || {};
        this.waterConfig = {
          enabled,
          type,
          text: utils.getOpenData(watermarkContent),
          color: `#${otherColor}`,
          opacity: parseInt(otherAlpha, 10),
          fontSize: otherFontSize
        };
        console.log('this.waterConfig', this.waterConfig);
      } catch (e) {
        console.log(e);
      }
    },
    // 倍速配置
    async setMultiConfig() {
      try {
        const res = await getMultiConfig();
        const {enabled, multipleMode, multipleStudy} = res;
        this.multiConfig = {
          enabled: ~~enabled,
          multipleMode: ~~multipleMode,
          multipleStudy: ~~multipleStudy
        };
      } catch (e) {
        console.log(e);
      }
    },
    // 拖动配置
    async setCheatInfo() {
      try {
        const res = await getCheatInfo();
        this.config.forbidDrag = res.enableForbidDrag === 1;
      } catch (e) {
        console.log(e);
      }
    },
    // 人脸配置
    async setFaceConfig() {
      try {
        const res = await getFaceConfig();
        res.kngEnabled = res.enabled;
        this.faceConfig = res;
      } catch (e) {
        console.log(e);
      }
    },
    // 获取AI字幕的余量
    async setAITime() {
      try {
        const res = await getRestTimeOfAI();
        this.config.canUseAI = res && res.accountTime > 0;
      } catch (e) {
        console.log(e);
      }
    },
    // 角色权限配置
    async setPermissionConfig() {
      this.permissionConfig.editHours = commonUtil.checkActionPermission('kng_courseware_mgmt', 'Editing_courseware_hours', this);
      this.permissionConfig.editCredits = commonUtil.checkActionPermission('kng_courseware_mgmt', 'Editing_courseware_credits', this);
      const res = await getRestTimeOfAI();
      this.config.canUseAI = res && res.accountTime > 0;
    }
    // async getZipOrgParams() {
    //   try {
    //     const res = await getOrgParameter('KngUploadZip', localStorage.orgId);
    //     this.enableUploadZip = Boolean(~~res.value);
    //   } catch (error) { }
    // }
  }
};
